import React, { useEffect } from "react";
import { List, ListItem, ListItemText, Typography, Paper, CircularProgress, Link, Alert } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useUser } from "shared/helpers/axios";
import useFeedAPI from "shared/hooks/useFeedAPI";

function MySuggestions() {
  const { user } = useUser();
  const {
    suggestions,
    loading,
    error,
    fetchSuggestions
  } = useFeedAPI();

  useEffect(() => {
    if (user) {
      fetchSuggestions();
    }
  }, [user, fetchSuggestions]);

  return (
    <Paper sx={{ p: 2, mt: 0 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Suggestions to Friends
      </Typography>

      {loading ? (
        <CircularProgress sx={{ display: "block", margin: "auto", mt: 2 }} />
      ) : error ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      ) : (
        <List>
          {suggestions.sent.length === 0 ? (
            <Typography>No suggestions sent.</Typography>
          ) : (
            suggestions.sent.map((s) => (
              <ListItem key={s.id} divider>
                <ListItemText
                  primary={s.receiver?.first_name && s.receiver?.last_name 
                    ? `${s.receiver.first_name} ${s.receiver.last_name}` 
                    : s.receiver?.name || 'Unknown User'}
                  secondary={
                    <>
                      <Typography component="span" variant="body2" color="textSecondary">
                        {s.body}
                      </Typography> 
                      <br />
                      {s.call && (
                        <>
                          <Link
                            component={RouterLink}
                            to={`/funding/call/${s.call.id || s.call.heu_id}/`} // Use id or heu_id
                            color="primary"
                          >
                            {s.call.title || "Loading..."} {/* Show title if available */}
                          </Link>
                        </>
                      )}
                    </>
                  }
                />
              </ListItem>
            ))
          )}
        </List>
      )}
    </Paper>
  );
}

export default MySuggestions;
